import React from 'react';
import { FormTheme } from '../../types';

interface ProgressBarProps {
  current: number;
  total: number;
  theme?: Partial<FormTheme>;
}

export function ProgressBar({ current, total }: ProgressBarProps) {
  const percentage = Math.round((current / total) * 100);

  return (
    <div style={{ width: '100%', marginBottom: '1.5rem' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '0.5rem',
      }}>
        <span style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--hexaforms-text)' }}>
          Paso {current} de {total}
        </span>
        <span style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--hexaforms-primary)' }}>
          {percentage}%
        </span>
      </div>
      <div style={{
        width: '100%',
        height: '0.5rem',
        backgroundColor: 'var(--hexaforms-border)',
        borderRadius: '9999px',
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          width: `${percentage}%`,
          backgroundColor: 'var(--hexaforms-primary)',
          borderRadius: '9999px',
          transition: 'width 0.3s ease-out',
        }} />
      </div>
    </div>
  );
}
